// @ts-nocheck
/* eslint-disable */
export const lowIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="#2953B2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m2.667 7.334 5.333 2 5.333-2"/></svg>`,
    name: 'low' as const
};